<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1294 1319">
    <defs>
        <clipPath id="clip-Artboard_2">
            <rect width="1294" height="1319" />
        </clipPath>
    </defs>
    <g id="Artboard_2" data-name="Artboard – 2" clip-path="url(#clip-Artboard_2)">
        <rect width="1294" height="1319" fill="#fff" />
        <g id="Group_1" data-name="Group 1" transform="translate(-239.815 -204.006)">
            <path id="Path_4" data-name="Path 4" d="M765.618-755.191,1937.767,401.778" class="red"
                transform="translate(-464.926 1023)" fill="none" stroke="currentColor" stroke-linecap="round"
                stroke-width="100" />
            <path id="Path_5" data-name="Path 5" d="M0,0,1156.969,1172.148"
                transform="translate(1472.841 267.809) rotate(90)" fill="none" stroke="currentColor"
                stroke-linecap="round" stroke-width="100" />
        </g>
    </g>
</svg>